import { Component } from 'vue-property-decorator';
import AbstractTable from '@shared/components/tables/abstract-table/abstract-table';
import { mixins } from 'vue-class-component';
import BpcPageTitle from '@shared/layouts/components/page-title/page-title.vue';
import EntityTable from '@shared/components/tables/entity-table/entity-table.vue';
import { Mandate } from '@accounting/interfaces/mandate';
import EntityTableProvider from '@shared/components/tables/entity-table-provider/entity-table-provider.vue';
import StdFilter from '@shared/components/filters/std-filter/std-filter.vue';
import StdForm from '@shared/components/forms/auto-form/std-form/std-form.vue';
import DrawerModal from '@shared/components/modals/drawer-modal/drawer-modal.vue';
import SendMessageUsingTemplateMixin from '@shared/components/tables/abstract-table/send-message-using-template-mixing';
import ConfirmationModal from '@shared/components/modals/confirmation-modal/confirmation-modal.vue';
import EntityDeleteModalProvider from '@shared/components/modals/entity-delete-modal-provider/entity-delete-modal-provider.vue';
import EntityFormProvider from '@shared/components/forms/auto-form/entity-form-provider/entity-form-provider.vue';
import MandateForm from '@accounting/components/forms/mandate-form/mandate-form.vue';

@Component({
  name: 'bpc-mandate-table',
  components: {
    'bpc-entity-table-provider': EntityTableProvider,
    'bpc-page-title': BpcPageTitle,
    'bpc-entity-table': EntityTable,
    'bpc-std-filter': StdFilter,
    'bpc-std-form': StdForm,
    'bpc-drawer-modal': DrawerModal,
    'bpc-confirmation-modal': ConfirmationModal,
    'bpc-entity-delete-modal-provider': EntityDeleteModalProvider,
    'bc-mandate-form': MandateForm,
  },
})
export default class MandateTable extends mixins(AbstractTable, SendMessageUsingTemplateMixin) {
  declare $refs: AbstractTable['$refs'] & {
    stdForm: InstanceType<typeof StdForm> & {
      saveEntity(): void;
      formModel: any;
      onDeleteMediaFile(): void;
      searchEntity(): void;
      extraData: string | AnyEntity;
      formProvider: EntityFormProvider;
    };
  };

  public entity: Mandate = null;
  public entityName = 'mandate';
  public pluralEntityName = 'mandates';
  public permissionEntityNameToUse = 'mandates';
  public formModel: Mandate = null;

  public customRowActions = {
    sendMessageUsingTemplate: {
      activated: true,
      type: 'action',
      icon: 'envelope',
      show: true,
      event: 'send-message-using-template',
      text: 'send_message_using_template',
      permissions: ['send'],
    },
    softDelete: {
      activated: true,
      type: 'action',
      icon: 'trash',
      show: true,
      event: 'soft-delete',
      text: 'soft-delete',
      permissions: ['delete'],
    },
  };

  extendUpdateRowActions(entity: any) {
    if (entity?.status) {
      if (entity.status === 'FRST') {
        entity.actions.softDelete.show = true;
      } else {
        entity.actions.softDelete.show = false;
      }
    }
    return null;
  }

  customOnRowAction($event: { event: string; item: any }) {
    switch ($event.event) {
      case 'send-message-using-template':
        this.onSendMessageUsingTemplate($event.item.item);
        break;
    }
  }
}
